import React from 'react';
import { connect } from 'react-redux';
import { get, isNumber, identity } from 'lodash/fp';

const Placeholder = () => <span className="c-brand-gray-light">–</span>;

const Figure = ({ value, name, render = identity }) => (
  <div className="ContentPerformanceFigure">
    {isNumber(value) ? render(value) : <Placeholder />}
  </div>
);

const mapStateToProps = ({ pathBuilder }, props) => ({
  value: get(
    `performance.pathContents[${props.for}].${props.name}`,
    pathBuilder.reporting,
  ),
});

const FigureConnected = connect(mapStateToProps)(Figure);

/**
 * Connecting to redux store is optional if we pass an explicit `value` prop to
 * ContentPerformanceFigure.
 */
const ContentPerformanceFigure = props => {
  if (props.value) {
    return <Figure {...props} />;
  }
  return <FigureConnected {...props} />;
};

export default ContentPerformanceFigure;
